export default () => ({
    textField: {
        width: '100%',
        marginTop: 16,
        marginBottom: 8
    }
});
